import React, { useEffect, useState } from "react";
import {
Box,
Card,
Typography,
Stack,
TextField,
Button,
Alert,
CircularProgress
} from "@mui/material";

import { Colors } from "../utils/colors";
import BackHeader from "../components/BackHeader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { API } from "../constant/apiConstant";

export default function HelpSupport(){

const navigate = useNavigate()

const isAuthenticated = useSelector((state)=>state.appState.isAuthenticated)
const user = useSelector((state)=>state.appState.user)

const [loading,setLoading] = useState(false)
const [settings,setSettings] = useState(null)

const [alert,setAlert] = useState({
open:false,
severity:"success",
message:""
})

const [form,setForm] = useState({
name:"",
subject:"",
message:""
})
const [submissionKey,setSubmissionKey] = useState(() =>
  window.crypto?.randomUUID?.() || `support_${Date.now()}_${Math.random().toString(36).slice(2)}`
)

useEffect(()=>{
if(user){
setForm((prev)=>({
...prev,
name: prev.name || `${user.first_name || ""} ${user.last_name || ""}`.trim()
}))
}
},[user])



useEffect(()=>{

if(!isAuthenticated){

navigate("/login")

}

},[isAuthenticated,navigate])

useEffect(()=>{
const loadSettings = async () => {
try{
const res = await fetch(`${API.BASE_URL}/api/settings`,{
method:"GET",
headers:{
"Content-Type":"application/json"
}
})

const data = await res.json()

if(data?.status){
setSettings(data.settings)
}
}catch(error){
console.log("Settings error:",error)
}
}

loadSettings()
},[])




const update = (field,value)=>{

setForm(prev=>({
...prev,
[field]:value
}))

}




const showAlert=(severity,message,time=6000)=>{

setAlert({
open:true,
severity,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,open:false}))
},time)

}




const sendMessage = async () => {

if(!form.name.trim() || !form.subject.trim() || !form.message.trim()){

showAlert("error","All fields are required")
return

}

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/messages/support-message`,{
method:"POST",
credentials:"include",
headers:{
"Content-Type":"application/json",
"X-Idempotency-Key":submissionKey,
},
body:JSON.stringify(form)
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Unable to send message")
setLoading(false)
return

}

showAlert("success","Message sent successfully")

setForm({
name: user ? `${user.first_name || ""} ${user.last_name || ""}`.trim() : "",
subject:"",
message:""
})
setSubmissionKey(window.crypto?.randomUUID?.() || `support_${Date.now()}_${Math.random().toString(36).slice(2)}`)

}catch(error){

console.log(error)

showAlert("error","Unable to connect to server")

}

setLoading(false)

}


return(

<Box
sx={{
minHeight:"100vh",
p:3,
background:Colors.secondary,
display:"flex",
justifyContent:"center"
}}
>

<Box sx={{width:"100%",maxWidth:700}}>

<BackHeader
title="Help & Support"
fallbackRoute="/account/authmenu"
titleSx={{color:"#ffb300",fontWeight:700}}
/>


{alert.open && (
<Alert severity={alert.severity} sx={{mb:2}}>
{alert.message}
</Alert>
)}




<Card
sx={{
p:3,
mb:3,
borderRadius:2,
background:"linear-gradient(180deg,#0b2a4a,#071f36)",
border:"1px solid #1e3a5f"
}}
>

<Typography sx={{color:"#fff",mb:2}}>
Support Contacts
</Typography>

<Stack spacing={1}>

<Typography sx={{color:"#90caf9"}}>
Support Email: {settings?.support_email || "support@fliplottery.com"}
</Typography>

<Typography sx={{color:"#90caf9"}}>
Billing Support: {settings?.billing_support_email || "billing@fliplottery.com"}
</Typography>

<Typography sx={{color:"#90caf9"}}>
Technical Support: {settings?.tech_support_email || "tech@fliplottery.com"}
</Typography>

<Typography sx={{color:"#90caf9"}}>
Phone: {settings?.support_phone || "+234 800 000 0000"}
</Typography>

</Stack>

</Card>




<Card
sx={{
p:3,
borderRadius:2,
background:"linear-gradient(180deg,#0b2a4a,#071f36)",
border:"1px solid #1e3a5f"
}}
>

<Typography sx={{color:"#fff",mb:2}}>
Contact Support
</Typography>

<Stack spacing={2}>

<TextField
label="Your Name"
value={form.name}
onChange={(e)=>update("name",e.target.value)}
fullWidth
InputProps={{style:{color:"white"}}}
/>

<TextField
label="Subject"
value={form.subject}
onChange={(e)=>update("subject",e.target.value)}
fullWidth
InputProps={{style:{color:"white"}}}
/>

<TextField
label="Message"
value={form.message}
onChange={(e)=>update("message",e.target.value)}
fullWidth
multiline
rows={4}
InputProps={{style:{color:"white"}}}
/>

<Button
variant="contained"
fullWidth
onClick={sendMessage}
disabled={loading}
sx={{
bgcolor:Colors.accent,
color:"#003300",
fontWeight:700
}}
>

{loading
? <CircularProgress size={24}/>
: "Send Message"
}

</Button>

</Stack>

</Card>

</Box>

</Box>

)

}
